import {Button} from "@/components/ui/Button";
import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {Dialog} from "@/components/ui/dialog";
import {DialogContent} from "@/components/ui/dialog";
import {Icon} from "@/components/ui/icon";
import {cn} from "@/lib/utils";
import {RefreshCcw} from "lucide-react";

export const TryAgainModal = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}) => {
  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className={cn("w-110 min-w-110 block overflow-hidden")}>
        <DialogHeader className="sr-only">
          <DialogTitle>Something went wrong</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">
          Refresh the page to try again.
        </DialogDescription>
        <div className="bg-white p-6 rounded-lg w-110 flex flex-col items-center gap-5">
          <Icon
            className="bg-opacity-10 border-opacity-30 rounded-lg bg-primary border-primary"
            size="lg"
          >
            <RefreshCcw className="text-primary-accent" size={28} />
          </Icon>
          <div className="flex flex-col items-center gap-2 text-center">
            <h2 className="text-lg font-bold">Something went wrong</h2>
            <p className="text-sm text-label">
              Please try refreshing the page or try again later. If the problem
              persists, please contact support.
            </p>
          </div>
          <div className="flex justify-between w-full gap-3">
            <Button onClick={() => window.location.reload()} className="w-full">
              Refresh
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
